import angular from 'angular'

import { homeRoutes } from './home.routes'
import { homeService } from './services/home.service'
import { homeWidget } from './directives/home-widget/home-widget.directive'
import { homeTasks } from './directives/home-tasks/home-tasks.directive'
import { homeCampaigns } from './directives/home-campaigns/home-campaigns.directive'
import { homeTasksItem } from './directives/home-tasks-item/home-tasks-item.directive'
import { homePosts } from './directives/home-posts/home-posts.directive'
import { homePostsItem } from './directives/home-posts-item/home-posts-item.directive'
import { homeCampaignsItem } from './directives/home-campaigns-item/home-campaigns-item.directive'
import { homeTemplates } from './directives/home-templates/home-templates.directive'
import { homeTemplatesItem } from './directives/home-templates-item/home-templates-item.directive'
import { homeCampaignsFinishingSoon } from './directives/home-campaigns-finishing-soon/home-campaigns-finishing-soon.directive'

import { analyticsInsightsHome } from '../analytics/directives/analytics-insights-home/analytics-insights-home.directive'

const module = angular
  .module('deskfy.home', [])
  .config(homeRoutes)
  .factory('HomeService', homeService)
  .directive('homeCampaigns', homeCampaigns)
  .directive('homeWidget', homeWidget)
  .directive('homeTasksItem', homeTasksItem)
  .directive('homeTasks', homeTasks)
  .directive('homePosts', homePosts)
  .directive('homePostsItem', homePostsItem)
  .directive('homeCampaignsItem', homeCampaignsItem)
  .directive('homeTemplates', homeTemplates)
  .directive('homeTemplatesItem', homeTemplatesItem)
  .directive('homeCampaignsFinishingSoon', homeCampaignsFinishingSoon)

  .directive('analyticsInsightsHome', analyticsInsightsHome)

export const homeModule = module
